import React, { useState, useEffect, useRef } from 'react';
import ResultItem from './bper-results-item';
import parseHTML from 'html-react-parser';

function Results({
	locations,
	idSelected,
	setSelected,
	place,
	apiKey,
	configurations,
	translations,
	showServiceInfo,
	setShowServiceInfo
}) {

	const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
	function simulateMouseClick(element){
		mouseClickEvents.forEach(mouseEventType =>
			element.dispatchEvent(
				new MouseEvent(mouseEventType, {
					view: window,
					bubbles: true,
					cancelable: true,
					buttons: 1
				})
			)
		);
	}

	const refs =
		locations === undefined
			? undefined
			: locations.reduce((acc, value) => {
				acc[value.id] = React.createRef();
				return acc;
			}, {});

	const [isShow, setIsShow] = useState(false);

	const showList = () => {
		setIsShow(!isShow);
	};

	const storeList = useRef(null);

	useEffect(() => {
		if (window.innerWidth > 991 && idSelected !== undefined && refs[idSelected] !== undefined) {
			try {
				var element = document.querySelector('#buttonShowList');
				if(!isShow){
					simulateMouseClick(element);
				}
			} catch (er) {
				console.warn("Error", er);
			}
		}
	}, [idSelected]);

	const setMarkerSelected = (obj) => {
		setSelected(obj);
	};

	useEffect(() => {
		if (window.innerWidth > 991 && idSelected !== undefined && refs[idSelected] !== undefined) {
			try {
				storeList.current.scrollLeft = refs[idSelected].current.offsetLeft;
			} catch (er) {
				console.warn("Error", er);
			}
		}
	}, [idSelected]);

	useEffect(() => {
		//di default scrolla al top della lista
		try {
			if (window.innerWidth > 991) {
				storeList.current.scrollLeft = 0;
			}
		} catch (er) {
			console.warn("Error", er);
		}
	}, []);

	useEffect(() => {
		//di default scrolla al top della lista
		try {
			if (window.innerWidth > 991) {
				storeList.current.scrollLeft = 0;
			}
		} catch (er) {
			console.warn("Error", er);
		}
	}, [locations]);

    const locationsSize = (locations === undefined || locations.length === 0) ? 0 : locations.length;

	return (
	    <>
            <div class="div-switch-show-list">
                <div class="total-subsidiary | font-body-l">
                    {translations.resultsFound} <span className="fw-300">{locationsSize}</span>
                </div>
				<label htmlFor="buttonShowList" className="label-button-map-mobile | font-body-m fw-400">{translations.onlyMap}</label>
				<label class="switch-show-list">
                    <input class="button-show-list" type="checkbox" role="switch" id="buttonShowList" onChange={showList}/>
                    <span class="slider round"></span>
                </label>
                <label htmlFor="buttonShowList" className="label-button-show-list | font-body-m fw-400">{translations.showList}</label>
                <label htmlFor="buttonShowList" className="label-button-hide-list | font-body-m fw-400">{translations.hideList}</label>
                <label htmlFor="buttonShowList" className="label-button-list-mobile | font-body-m fw-400">{translations.onlyList}</label>
            </div>
            <div id="store-list" ref={storeList}>
                {window.google && isShow &&
                    locations &&
                    locations.sort((a, b) => (a.distanceValue && a.distanceValue > b.distanceValue) ? 1 : ((b.distanceValue && b.distanceValue > a.distanceValue) ? -1 : 0)).map((el, i) => {
                        const currentSubsidiary =
                            idSelected !== undefined && idSelected === el.id + '';
                        const cssClass = currentSubsidiary
                            ? 'store-list-item selected'
                            : 'store-list-item';
                        const currentDay = new Date().getDay();
                        const currentTime = new Date();
                        const currentDate = new Date().toISOString().split('T')[0]; //es.2020-11-25
                        const time_mattino =
                            currentDay === 1
                                ? el.timetables && el.timetables.openMondayMorning
                                : currentDay === 2
                                    ? el.timetables && el.timetables.openTuesdayMorning
                                    : currentDay === 3
                                        ? el.timetables && el.timetables.openWednesdayMorning
                                        : currentDay === 4
                                            ? el.timetables && el.timetables.openThursdayMorning
                                            : currentDay === 5
                                                ? el.timetables && el.timetables.openFridayMorning
                                                : currentDay === 6
                                                    ? el.timetables && el.timetables.openSaturdayMorning
                                                    : el.timetables && el.timetables.openSundayMorning; //currentDay=7

                        const time_pomeriggio =
                            currentDay === 1
                                ? el.timetables && el.timetables.openMondayAfternoon
                                : currentDay === 2
                                    ? el.timetables && el.timetables.openTuesdayAfternoon
                                    : currentDay === 3
                                        ? el.timetables && el.timetables.openWednesdayAfternoon
                                        : currentDay === 4
                                            ? el.timetables && el.timetables.openThursdayAfternoon
                                            : currentDay === 5
                                                ? el.timetables && el.timetables.openFridayAfternoon
                                                : currentDay === 6
                                                    ? el.timetables && el.timetables.openSaturdayAfternoon
                                                    : el.timetables && el.timetables.openSundayAfternoon; //currentDay=7
                        const time_start_mattino =
                            time_mattino && time_mattino.toLowerCase() !== 'chiuso'
                                ? new Date(
                                    currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                                    time_mattino.split(' ')[0].split(".")[0],time_mattino.split(' ')[0].split(".")[1]
                                )
                                : undefined;
                        const time_end_mattino =
                            time_mattino && time_mattino.toLowerCase() !== 'chiuso'
                                ? new Date(
                                    currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                                    time_mattino.split(' ')[1].split(".")[0],time_mattino.split(' ')[1].split(".")[1]
                                )
                                : undefined;
                        const time_start_pomeriggio =
                            time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
                                ? new Date(
                                    currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                                    time_pomeriggio.split(' ')[0].split(".")[0],time_pomeriggio.split(' ')[0].split(".")[1]
                                )
                                : undefined;
                        const time_end_pomeriggio =
                            time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
                                ? new Date(
                                    currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                                    time_pomeriggio.split(' ')[1].split(".")[0],time_pomeriggio.split(' ')[1].split(".")[1]
                                )
                                : undefined;

                        let stringOpenTime = '';

                        if (time_start_mattino && time_start_pomeriggio) {

                            if (currentTime < time_start_mattino) {
                                stringOpenTime =
                                    translations.NowCloseOpenAt + (time_mattino && time_mattino.split(' ')[0]);
                            } else {
                                if (currentTime < time_end_mattino) {
                                    stringOpenTime =
                                        translations.OpenCloseAt + (time_mattino && time_mattino.split(' ')[1]);

                                } else {
                                    if (currentTime < time_start_pomeriggio) {
                                        stringOpenTime =
                                            translations.NowCloseOpenAt + (time_pomeriggio && time_pomeriggio.split(' ')[0]);
                                    } else {
                                        if (currentTime < time_end_pomeriggio) {
                                            stringOpenTime =
                                                translations.OpenCloseAt + (time_pomeriggio && time_pomeriggio.split(' ')[1]);
                                        } else {
                                            stringOpenTime = "<b>" + translations.NowClose + "</b>";
                                        }
                                    }
                                }
                            }
                        }



                        const sameLunediVenerdi =
                            el.timetables && (el.timetables.openMondayMorning === el.timetables.openTuesdayMorning &&
                                el.timetables.openMondayMorning === el.timetables.openWednesdayMorning &&
                                el.timetables.openMondayMorning === el.timetables.openThursdayMorning &&
                                el.timetables.openMondayMorning === el.timetables.openFridayMorning &&
                                el.timetables.openMondayAfternoon === el.timetables.openTuesdayAfternoon &&
                                el.timetables.openMondayAfternoon === el.timetables.openWednesdayAfternoon &&
                                el.timetables.openMondayAfternoon === el.timetables.openThursdayAfternoon &&
                                el.timetables.openMondayAfternoon === el.timetables.openFridayAfternoon);


                        const sameSabatoDomenicaChiuso =
                            el.timetables && (el.timetables.openSaturdayMorning.toLowerCase() === 'chiuso' &&
                                el.timetables.openSundayMorning.toLowerCase() === 'chiuso' &&
                                el.timetables.openSaturdayAfternoon.toLowerCase() === 'chiuso' &&
                                el.timetables.openSundayAfternoon.toLowerCase() === 'chiuso');

                        const linkIndicazioniStradali = place
                            ? 'https://www.google.com/maps/dir/' +
                            place.lat +
                            ',' +
                            place.lng +
                            '/' +
                            el.latitude +
                            ',' +
                            el.longitude
                            : el
                                ? 'https://www.google.com/maps/dir/' +
                                '/' +
                                el.latitude +
                                ',' +
                                el.longitude
                                : undefined;

                        const objDistanze = place ? {
                            origin: new window.google.maps.LatLng(
                                place.lat,
                                place.lng
                            ),
                            destination: new window.google.maps.LatLng(
                                el.latitude,
                                el.longitude
                            )
                        } : undefined;






                        return (
                            <div className="store-list-item-wrapper" ref={refs[el.id]} key={'result_item_' + el.id}>
                                <ResultItem
                                    el={el}
                                    key={'result_obj_' + el.id}
                                    translations={translations}
                                    stringOpenTime={stringOpenTime}
                                    sameLunediVenerdi={sameLunediVenerdi}
                                    sameSabatoDomenicaChiuso={sameSabatoDomenicaChiuso}
                                    linkIndicazioniStradali={linkIndicazioniStradali}
                                    cssClass={cssClass}
                                    objDistanze={objDistanze}
                                    showServiceInfo={showServiceInfo}
                                    setShowServiceInfo={setShowServiceInfo}
                                    //linkDistance={"https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=" + place.lat + "," + place.lng + "&destinations=" + el.latitude + "%2C" + el.longitude + "&key=" + apiKey}
                                    setMarkerSelected={setMarkerSelected}
                                    configurations={configurations}
                                    currentSubsidiary={currentSubsidiary}
                                />
                            </div>
                        );
                    })}
                {locations === undefined || locations.length === 0 ? (
                    <>
                        <p id="noresult" className="noresult-text">
                            <b>{translations.noResultsInThisCity}</b>.
                        </p>
                    </>
                ) : (
                        <></>
                    )}
            </div>
		</>
	);
}

export default Results;
